import React from "react";
import Searching from "./../../Components/searchingInclusion";

function SearchingInclusionPage() {
  return (
    <div>
      <div className="content-wrapperv">
        <Searching />
      </div>
    </div>
  );
}

export default SearchingInclusionPage;
